package one.healthium.profile.navigation.food_history

import com.arkivanov.decompose.ComponentContext
import one.healthium.profile.ui.food_history.models.FoodItemUiModel

class DefaultFoodHistoryComponent(
    componentContext: ComponentContext,
    private val onBackClicked: () -> Unit,
    private val onFoodItemClicked: (FoodItemUiModel) -> Unit,
) : FoodHistoryComponent, ComponentContext by componentContext {
    override fun onBackClicked() {
        onBackClicked.invoke()
    }

    override fun onFoodItemClicked(foodItem: FoodItemUiModel) {
        onFoodItemClicked.invoke(foodItem)
    }
}